module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-13.fe27a6b2.png";